import { RHTextSanitizer } from "../Custom components/RH/Utils_slop/RHTextSanitizer"


export class RHProcurementAmendmentPresentation {

    static descriptionHTML(
        procurementTitle: string | undefined
    ): string {
        let description = "Hanget on muudetud."
        if (typeof procurementTitle === "string" && procurementTitle) {
            description =
                `Hanget „${RHTextSanitizer.escapedHTML(procurementTitle)}“ on muudetud.`
        }

        return description + "<br>Täpsem info on leitav hanke teabevahetusest."
    }

}
